import React from 'react';
import clsx from 'clsx';
import { KTSVG } from 'src/_metronic/helpers';
import { translate } from 'src/locales/i18next/config';
import Translations from 'src/locales/i18next/translations/translation';
import { useSellerEvaluation } from '../../services';
import { Gauge } from '../gauge';

type Props = {};

export default function SellerEvaluation({}: Props) {
  const t = translate(Translations);
  const translation = 'pages.dashboard.sellerEvaluation';

  const { data } = useSellerEvaluation();
  return (
    <div>
      <h3 className="mb-7">{t(`${translation}.title`)}</h3>
      <div className="row">
        <div className="col-lg-3 mb-5">
          <div className="card">
            <div className="position-absolute shadow-sm rounded-sm px-4 py-2 mt-3 ms-3">
              <span className="text-gray-800 fw-bold fs-7">{Number(data?.scoreInfo?.vendorScore)} / 10</span>
            </div>
            <div className="d-flex align-items-center justify-content-center">
              <Gauge value={Number(data?.scoreInfo?.vendorScore)} />
            </div>
          </div>
        </div>
        <div className="col-lg-9 mb-5">
          <div className="card px-3 py-3 h-100 d-flex justify-content-center w-100 flex-column overflow-x-auto">
            <div className="d-flex align-items-center justify-content-between text-center mb-5 flex-nowrap">
              <div className="min-w-100px"></div>
              <div className="min-w-200px">
                <span className="fw-bolder text-decoration-underline fs-6 text-nowrap">Sipariş Adedi</span>
              </div>
              <div className="min-w-250px">
                <span className="fw-bolder text-decoration-underline fs-6 text-nowrap">Kargoya Verilmiş Sipariş Adedi</span>
              </div>
              <div className="min-w-200px">
                <span className="fw-bolder text-decoration-underline fs-6 text-nowrap">Müşteri Değerlendirmeleri</span>
              </div>
              <div className="min-w-200px">
                <span className="fw-bolder text-decoration-underline fs-6 text-nowrap">Cevap Bekleyen Soru Adedi</span>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between text-center mb-5 flex-nowrap">
              <div className="min-w-100px text-start">Son 1 Ay</div>
              <div className="min-w-200px">
                <span className="fs-6">{data?.countInfo?.shipmentCounts?.totalItemCountOneMonth}</span>
              </div>
              <div className="min-w-200px">
                <span>{data?.countInfo?.shipmentCounts?.totalItemCountOneMonthInCargo}</span>
              </div>
              <div className="min-w-200px">
                <span>{data?.countInfo?.orderReviewCounts?.totalItemCountOneMonth}</span>
              </div>
              <div className="min-w-200px">
                <span>{data?.countInfo?.unansweredQuestionCounts?.totalItemCountOneMonth}</span>
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between text-center mb-5 flex-nowrap">
              <div className="min-w-100px text-start">Son 3 Ay</div>
              <div className="min-w-200px">
                <span className="fs-6">{data?.countInfo?.shipmentCounts?.totalItemCountThreeMonth}</span>
              </div>
              <div className="min-w-200px">
                <span>{data?.countInfo?.shipmentCounts?.totalItemCountThreeMonthInCargo}</span>
              </div>
              <div className="min-w-200px">
                <span>{data?.countInfo?.orderReviewCounts.totalItemCountThreeMonth}</span>
              </div>
              <div className="min-w-200px">
                <span>{data?.countInfo?.unansweredQuestionCounts?.totalItemCountThreeMonth}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="card px-4 py-4">
            <div className="table-responsive">
              {/* begin::Table */}
              <table className="table  table-row-bordered  table-row-gray-100 align-middle gs-0 gy-3 ">
                {/* begin::Table head */}
                <thead className="bg-light">
                  <tr className="fw-bolder text-muted">
                    <th className="min-w-200px  ps-2">Performans Kriterleri</th>
                    <th className="min-w-200px border-start border-end">Hedef</th>
                    <th className="min-w-200px border-start border-end">Son 30 Gün Performansı</th>
                    <th className="min-w-200px border-start border-end">30 - 90 Gün Performansı</th>
                    <th className="min-w-200px">Satıcı Puanı</th>
                  </tr>
                </thead>
                {/* end::Table head */}
                {/* begin::Table body */}
                <tbody>
                  {data?.scoreInfo?.vendorScoreList?.map((score, index) => (
                    <tr className={clsx({ 'table-active': index % 2 === 1 })} key={index}>
                      <td className="ps-2">
                        <div>
                          <p className="text-dark fs-7 fw-bolder">{score?.title}</p>
                          <p className="text-dark fs-7 text-muted w-200px">{score?.description}</p>
                        </div>
                      </td>
                      <td className="border-start border-end">
                        <p className="text-dark fs-7">{score?.target ?? '-'}</p>
                      </td>
                      <td className="border-start border-end">
                        <p className="text-dark fs-7">{score?.last30DaysPerformance ?? '-'}</p>
                      </td>
                      <td className="border-start border-end">
                        <p className="text-dark fs-7">{score?.last30to90DaysPerformance ?? '-'}</p>
                      </td>
                      <td>
                        <p className="text-dark fs-7">{score?.vendorScore ?? '-'}</p>
                      </td>
                    </tr>
                  ))}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
